// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__213nA","error":"Textarea_error__N-YCl","readonly":"Textarea_readonly__13ZYF","disabled":"Textarea_disabled__3VwrQ"};